import React, { memo } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  filterControl: {
    minWidth: "200px"
  }
}));

// Add CSS to prevent scrollbar disappearing issue
const globalStyles = `
  .MuiModal-root {
    padding-right: 0 !important;
  }
  
  .MuiPopover-root {
    padding-right: 0 !important;
  }
  
  body.MuiModal-open {
    padding-right: 0 !important;
    overflow: auto !important;
  }
`;

// Inject global styles
if (typeof document !== 'undefined') {
  const styleElement = document.getElementById('category-filter-fix');
  if (!styleElement) {
    const style = document.createElement('style');
    style.id = 'category-filter-fix';
    style.textContent = globalStyles;
    document.head.appendChild(style);
  }
}

const CategoryFilter = memo(({ categories, selectedCategory, onCategoryChange, disabled }) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.filterControl}>
      <InputLabel>Filter By Category</InputLabel>
      <Select
        value={selectedCategory}
        onChange={(e) => onCategoryChange(e.target.value)}
        disabled={disabled}
        MenuProps={{
          disableScrollLock: true,
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          }
        }}
      >
        <MenuItem value="">All Posts</MenuItem>
        {categories.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name} ({category.post_count})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

CategoryFilter.displayName = 'CategoryFilter';

export default CategoryFilter;